import React from 'react'

export default function ButtonLightBlue({ onClick, className, type, as, children, ...rest }) {
    const baseClasses = 'w-32 sm:w-40 rounded bg-blue-900 font-semibold flex justify-center cursor-pointer text-xs text-blue-100 py-2 px-4 sm:mr-0';
    const TagName = as ?? 'button';
    const isButton = TagName == 'button';
    const defaultOnClick = () => ({});

    return (
        <TagName
            type={isButton && (type ?? 'button')}
            className={`${baseClasses} ${className ?? ''}`}
            onClick={onClick ?? defaultOnClick}
            {...rest}
        >
            {children}
        </TagName>
    )
}
